
import { defineComponent } from 'vue';
import loadScript from '@/Utilities/loadScript';
export default defineComponent({
    name: 'VideoPlayer',
    props:{
        source: {
            type: String,
            default: ''
        },
        poster: {
            type: String,
            default: null
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        muted:{
            type: Boolean,
            default: true
        },
        loop:{
            type: Boolean,
            default: false
        },
        showplay: {
            type: Boolean,
            default: false
        }
    },
    data(){
        let player: any|undefined;
        return{
            player,
            id: Math.floor(Math.random() * 9999),
            fullScreen: false,
            clicked: false,
            ended: false,
            playClass: '',
            playStarted: false,
            listEvents: ["fullscreenchange", "mozfullscreenchange", "webkitfullscreenchange", "msfullscreenchange",'onwebkitfullscreenchange','webkitendfullscreen']
        }
    },
    mounted() {
        let win: any = window as any;
        if (typeof win.Clappr === "undefined") {
            //if(this.autoplay){
                this.initClappr();
            //}
        } else {
            this.load();
        }
        this.listEvents.forEach(eventType => {
            document.addEventListener(eventType, this.fullScreenChange);
        });
    },
    beforeDestroy: function () {
        this.listEvents.forEach(eventType => {
            document.removeEventListener(eventType, this.fullScreenChange);
        });
    },
    methods:{
        isFullscreen(){
            let elem: HTMLElement|null = document.querySelector('#player' + this.id + ' .fullscreen');
            let doc: any = document as any;
            let test = doc.fullscreenElement || doc.msFullscreenElement || doc.mozFullScreen || doc.webkitIsFullScreen;
            return test ? 1 : (elem ? 2 : 0);
        },
        fullScreenChange(){
            let isFull    = this.isFullscreen();
            if(!isFull){
                if(this.playStarted){
                    this.$emit('fullscreenexit');
                }
            }
        },
        load(){
            if(this.player){
                return;
            }
            const $this = this;
            const options = {
                parentId: '#player' + this.id,
                source: this.source,
                events: {
                    onPlay: () => {
                        $this.ended = false;
                        if(!$this.playStarted || !$this.loop){
                            $this.setVisible(true);
                        }
                        $this.playClass = 'playing';
                        let el = $this.player?.core?.el ?? null;
                        $this.playStarted = true;
                        $this.$emit('onplay', el);
                    },
                    onEnded: () => {
                        $this.ended = true;
                        let elem: HTMLElement|null = $this.$el.querySelector('.play-wrapper');
                        if(elem){
                            elem.style.display = 'none';
                        }
                        if(!$this.loop){
                            $this.setVisible(false);
                        }
                        if($this.autoplay){
                            setTimeout(() => {
                                $this.player.play();
                            }, 700);
                        }
                        $this.playClass = 'stop';
                    }
                },
                mute: $this.muted,
                loop: $this.loop,
                poster: $this.poster,
                disable_keyboard_shortcuts: false,
                disable_context_menu: true,
                exitFullscreenOnEnd: false,
                playback: {
                    playInline: true,
                    recycleVideo: true,
                    controls: false
                },
                disableErrorScreen: true,
                height: "100%",
                width: "100%"
            };
            const win: any = window as any;
            this.player  = new win.Clappr.Player(options);
            this.player.configure({
                streaming: {
                    bufferingGoal: 4,
                    bufferBehind: 4,
                    rebufferingGoal: 4
                }
            });

            if(this.autoplay){
                this.player.play();
            }
        },
        setVisible(val = true){
            const elem: HTMLElement|null = this.$el.querySelector('.player .container');
            if(elem){
                elem.style.opacity = val ? '1' : '0';
            }
        },
        initClappr(handler?: CallableFunction){
            //let scriptUrl = '/vendor/clappr/clappr_202008.min.js';
            //let scriptUrl = '/vendor/clappr/clappr_012023.min.js';
			let scriptUrl = '/vendor/clappr/clappr_09-jul-25.min.js';
            if(document.location.port == '8080'){
                scriptUrl = 'https://'+document.location.hostname+scriptUrl;
            }
            const _this = this;
            loadScript(scriptUrl,() => {
                _this.load();
                if(handler && typeof handler === 'function'){
                    handler();
                }
            });
        }
    }
});
